import buildBaseFigure from '@r1-frontend/ui-react/components/MovingBar/helpers/buildBaseFigure';

import { PointCoordinates, TPolygonDotsShapes, TwoPointCoords } from '../types';

const calculateOverflowEndPoint = (start: PointCoordinates, end: PointCoordinates, distance: number): PointCoordinates => {
    return {
        x: start.x + (end.x - start.x) * distance,
        y: start.y + (end.y - start.y) * distance,
    };
};
const buildOverflowFigure = (d: TPolygonDotsShapes, distance: number) => {
    const top: TwoPointCoords = { start: { x: d.left.x, y: d.left.top }, end: { x: d.right.x, y: d.right.top } };
    const bot: TwoPointCoords = { start: { x: d.left.x, y: d.left.bottom }, end: { x: d.right.x, y: d.right.bottom } };

    const t = calculateOverflowEndPoint(top.start, top.end, distance);
    const b = calculateOverflowEndPoint(bot.start, bot.end, distance);

    const result = buildBaseFigure(d);
    result[1] = `L${t.x} ${t.y}`;
    result[2] = `L${b.x} ${b.y}`;

    return result;
};

export default buildOverflowFigure;
